import { Station } from '@app/core/types/stations';
import { LinkItem, TranslateRawFn } from '@mi-front/ui';
import { defineMessage } from 'react-intl';

const auditMediaTabMessage = defineMessage({
  id: 'audit.audiosScreen.tabTitle',
  defaultMessage: 'Media',
});

export function getAuditStationHeaderLinks(
  station: Station,
  formatMessage: TranslateRawFn,
): readonly LinkItem[] {
  return [
    {
      //icon: <AssignmentTurnedInIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/matches`,
      text: formatMessage({
        id: 'audit.matchesScreen.title',
        defaultMessage: 'Matches',
      }),
    },
    {
      //icon: <CalendarMonthIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/schedule`,
      text: formatMessage({
        id: 'audit.schedulesListScreen.title',
        defaultMessage: 'Schedules',
      }),
      isActive: (match, location) => {
        return /\/schedule\//.test(location.pathname) || /\/schedule\?/.test(location.pathname);
      },
    },
    {
      //icon: <TaskIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/schedule-status`,
      text: formatMessage({
        id: 'audit.scheduleStatusScreen.title',
        defaultMessage: 'Status',
      }),
    },
    {
      //icon: <AssessmentIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/reports`,
      text: formatMessage({
        id: 'audit.reportsScreen.title',
        defaultMessage: 'Reportes',
      }),
      isActive: (_match, location) => {
        const reportsPath = `/audit/s/${station.slug}/reports`;
        return location.pathname === reportsPath || location.pathname.startsWith(`${reportsPath}/`);
      },
    },
    {
      exact: true,
      //icon: <AudioFileIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/audios`,
      text: formatMessage(auditMediaTabMessage),
    },
    {
      //icon: <UploadIcon fontSize="small" />,
      to: `/audit/s/${station.slug}/upload`,
      text: formatMessage({
        id: 'audit.uploadScreen.title',
        defaultMessage: 'Cargar archivos',
      }),
    },
  ];
}
